module.exports = __webpack_public_path__ + "static/media/BIONICKIDSLANTED3D.b3a7bd4b.ttf";